/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class NodeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * @return Success
     */
    findWebNodeList(): Promise<WebNodeDtoListApiResultDto> {
        let url_ = this.baseUrl + this.covertUrl('http://192.168.3.251/iot-remoteterminal-v2')+ "/Node/FindWebNodeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindWebNodeList(_response);
        });
    }

    protected processFindWebNodeList(response: AxiosResponse): Promise<WebNodeDtoListApiResultDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WebNodeDtoListApiResultDto.fromJS(resultData200) : new WebNodeDtoListApiResultDto();
            return result200;
        }
        return Promise.resolve<WebNodeDtoListApiResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    findGatewayNodeList(): Promise<GatewayNodeDtoListApiResultDto> {
        let url_ = this.baseUrl + this.covertUrl('http://192.168.3.251/iot-remoteterminal-v2')+ "/Node/FindGatewayNodeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindGatewayNodeList(_response);
        });
    }

    protected processFindGatewayNodeList(response: AxiosResponse): Promise<GatewayNodeDtoListApiResultDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? GatewayNodeDtoListApiResultDto.fromJS(resultData200) : new GatewayNodeDtoListApiResultDto();
            return result200;
        }
        return Promise.resolve<GatewayNodeDtoListApiResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    offlineGatewayNode(body: OfflineNodeDto | null | undefined): Promise<BooleanApiResultDto> {
        let url_ = this.baseUrl + this.covertUrl('http://192.168.3.251/iot-remoteterminal-v2')+ "/Node/OfflineGatewayNode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOfflineGatewayNode(_response);
        });
    }

    protected processOfflineGatewayNode(response: AxiosResponse): Promise<BooleanApiResultDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? BooleanApiResultDto.fromJS(resultData200) : new BooleanApiResultDto();
            return result200;
        }
        return Promise.resolve<BooleanApiResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    offlineWebNode(body: OfflineNodeDto | null | undefined): Promise<BooleanApiResultDto> {
        let url_ = this.baseUrl + this.covertUrl('http://192.168.3.251/iot-remoteterminal-v2')+ "/Node/OfflineWebNode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processOfflineWebNode(_response);
        });
    }

    protected processOfflineWebNode(response: AxiosResponse): Promise<BooleanApiResultDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? BooleanApiResultDto.fromJS(resultData200) : new BooleanApiResultDto();
            return result200;
        }
        return Promise.resolve<BooleanApiResultDto>(<any>null);
    }
}

export class BooleanApiResultDto implements IBooleanApiResultDto {
    code!: number | undefined;
    success!: boolean | undefined;
    msg!: string | undefined;
    data!: boolean | undefined;

    constructor(data?: IBooleanApiResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.success = data["success"];
            this.msg = data["msg"];
            this.data = data["data"];
        }
    }

    static fromJS(data: any): BooleanApiResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanApiResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["success"] = this.success;
        data["msg"] = this.msg;
        data["data"] = this.data;
        return data; 
    }
}

export interface IBooleanApiResultDto {
    code: number | undefined;
    success: boolean | undefined;
    msg: string | undefined;
    data: boolean | undefined;
}

export class GatewayNodeDto implements IGatewayNodeDto {
    webNodeList!: WebNodeDto[] | undefined;
    gatewayCode!: string | undefined;
    utcLoginTime!: Date | undefined;

    constructor(data?: IGatewayNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["webNodeList"] && data["webNodeList"].constructor === Array) {
                this.webNodeList = [] as any;
                for (let item of data["webNodeList"])
                    this.webNodeList!.push(WebNodeDto.fromJS(item));
            }
            this.gatewayCode = data["gatewayCode"];
            this.utcLoginTime = data["utcLoginTime"] ? new Date(data["utcLoginTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GatewayNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.webNodeList && this.webNodeList.constructor === Array) {
            data["webNodeList"] = [];
            for (let item of this.webNodeList)
                data["webNodeList"].push(item.toJSON());
        }
        data["gatewayCode"] = this.gatewayCode;
        data["utcLoginTime"] = this.utcLoginTime ? this.utcLoginTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGatewayNodeDto {
    webNodeList: WebNodeDto[] | undefined;
    gatewayCode: string | undefined;
    utcLoginTime: Date | undefined;
}

export class GatewayNodeDtoListApiResultDto implements IGatewayNodeDtoListApiResultDto {
    code!: number | undefined;
    success!: boolean | undefined;
    msg!: string | undefined;
    data!: GatewayNodeDto[] | undefined;

    constructor(data?: IGatewayNodeDtoListApiResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.success = data["success"];
            this.msg = data["msg"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(GatewayNodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GatewayNodeDtoListApiResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayNodeDtoListApiResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["success"] = this.success;
        data["msg"] = this.msg;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGatewayNodeDtoListApiResultDto {
    code: number | undefined;
    success: boolean | undefined;
    msg: string | undefined;
    data: GatewayNodeDto[] | undefined;
}

export class OfflineNodeDto implements IOfflineNodeDto {
    nodeId!: string | undefined;

    constructor(data?: IOfflineNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nodeId = data["nodeId"];
        }
    }

    static fromJS(data: any): OfflineNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfflineNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeId"] = this.nodeId;
        return data; 
    }
}

export interface IOfflineNodeDto {
    nodeId: string | undefined;
}

export class WebNodeDto implements IWebNodeDto {
    userName!: string | undefined;
    gatewayCode!: string | undefined;
    utcLoginTime!: Date | undefined;

    constructor(data?: IWebNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.gatewayCode = data["gatewayCode"];
            this.utcLoginTime = data["utcLoginTime"] ? new Date(data["utcLoginTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WebNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["gatewayCode"] = this.gatewayCode;
        data["utcLoginTime"] = this.utcLoginTime ? this.utcLoginTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IWebNodeDto {
    userName: string | undefined;
    gatewayCode: string | undefined;
    utcLoginTime: Date | undefined;
}

export class WebNodeDtoListApiResultDto implements IWebNodeDtoListApiResultDto {
    code!: number | undefined;
    success!: boolean | undefined;
    msg!: string | undefined;
    data!: WebNodeDto[] | undefined;

    constructor(data?: IWebNodeDtoListApiResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.success = data["success"];
            this.msg = data["msg"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(WebNodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WebNodeDtoListApiResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebNodeDtoListApiResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["success"] = this.success;
        data["msg"] = this.msg;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWebNodeDtoListApiResultDto {
    code: number | undefined;
    success: boolean | undefined;
    msg: string | undefined;
    data: WebNodeDto[] | undefined;
}